import { render, staticRenderFns } from "./MessageHistoryTable.vue?vue&type=template&id=2f58f4a8&scoped=true&lang=pug"
import script from "./MessageHistoryTable.vue?vue&type=script&lang=ts"
export * from "./MessageHistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoryTable.vue?vue&type=style&index=0&id=2f58f4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58f4a8",
  null
  
)

export default component.exports